import React from "react";
import {
    Box,
    Stepper,
    Step,
    StepIndicator,
    StepSeparator,
    StepTitle,
    StepStatus,
    StepIcon,
    StepNumber,
    StepDescription,
    useSteps,
} from "@chakra-ui/react";

const steps = [
    { title: "Bước 1", description: "Nhập tên Banner" },
    { title: "Bước 2", description: "Upload ảnh" },
    { title: "Bước 3", description: "Khởi tạo" },
];

export default function StepHeader({ step }) {
    const { activeStep } = useSteps({
        index: step,
        count: steps.length,
    })

    return (
        <Box mb={8} mr={"auto"} w={"full"}>
            <Stepper size="lg" index={activeStep}>
                {steps.map((step, index) => (
                    <Step key={index}>
                        <StepIndicator>
                            <StepStatus
                                complete={<StepIcon />}
                                incomplete={<StepNumber />}
                                active={<StepNumber />}
                            />
                        </StepIndicator>

                        <Box flexShrink='0'>
                            <StepTitle>{step.title}</StepTitle>
                            <StepDescription>{step.description}</StepDescription>
                        </Box>

                        <StepSeparator />
                    </Step>
                ))}
            </Stepper>
        </Box>
    );
}
